import React from "react";
import Icon from "./Icon";

export const TickQuaternaryDarkIcon = () => (
  <Icon>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20ZM16.38 8.29L10.5 14.17L8.62 12.29C8.23 11.9 7.6 11.9 7.21 12.29C6.82 12.68 6.82 13.31 7.21 13.7L9.8 16.29C10.19 16.68 10.82 16.68 11.21 16.29L17.8 9.7C18.19 9.31 18.19 8.68 17.8 8.29C17.41 7.9 16.77 7.9 16.38 8.29Z" fill="#D5D5D5"/>
  </Icon>
);
